/* eslint-disable */
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/home/Home";
import Website from "./components/Website";

function App() {
  return (
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/website" element={<Website />} />
      </Routes>
  );
}

export default App;
